import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseBranchesEquipmentsConsumptionsTotalizerProps<T> = {
  filters?: {
    clientBranchId?: string;
    consumptionCreatedAtGteq?: string;
    consumptionCreatedAtLteq?: string;
  };
  mapper?: (data: any) => T;
}

export const useBranchesEquipmentsConsumptionsTotalizer = <T,>({
  filters: {
    clientBranchId,
    consumptionCreatedAtGteq,
    consumptionCreatedAtLteq,
  } = {},
  mapper = Mapper.default<T>(),
}: UseBranchesEquipmentsConsumptionsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data } = defaultTransformerResponse(),
    ...rest
  } = useQuery({
    queryKey: [
      'clientCompanyBranchesEquipmentsConsumptionsTotalizer',
      clientBranchId,
      consumptionCreatedAtGteq,
      consumptionCreatedAtLteq,
    ],
    queryFn: () => {
      return privateAxios.get(`/companies/mine/branches_equipments_consumptions_totalizer`, {
        params: {
          'q[client_branch_id_eq]': clientBranchId,
          'q[consumption_created_at_gteq]': consumptionCreatedAtGteq,
          'q[consumption_created_at_lteq]': consumptionCreatedAtLteq,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, ...rest };
}
